import React, { useState } from "react";

const Popup = ({ details, onClose }) => {
  return (
    <div className="popup-overlay">
      <div className="popup">
        <button className="close-btn" onClick={onClose} style={{color: 'red', fontSize: '3vh', fontWeight: 'bolder'}}>X</button>
        <h2>Details</h2>
        <div className="details-grid">
          {details.map((dayDetails, index) => (
            <div key={index} className="details-row">
              <strong> {dayDetails}</strong>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const Schedule = () => {
  const [selectedWeek, setSelectedWeek] = useState(1);
  const [popupDetails, setPopupDetails] = useState(null);

  const [detailsByWeek, setDetailsByWeek] = useState({
    "1:0": [
      
        "Overview of Web Development",
        "Types of web development.",
        "Introduction to Web Designing.",
        "Guidelines for effective web designing.",
        "Hyperlinks and Text-Based Elements."
      ],

      "1:1":[
        "Roadmaps of Web Development",
        "Categories of web development: Frontend, Backend, Full-stack.",
        "HTML Basics: Tags, Attributes, Graphics.",
        "CSS Basics: Properties, Selections, Functions, Plugins.",
        "Advanced CSS / SASS"
      ],
      "1:2":[
        "Typography: Adding colors and gradients, Font Properties.",
        "Background properties.",
        "Lists and Forms: Ordered Lists, Unordered Lists, Form creation and Validation.",
        "Tables: Table structure, Border.",
        "Animation and Media Queries: Keyframes, Transitions, Responsiveness of webpage."
      ],
      "1:3":[
        "Backend Frameworks: JavaScript, React/NodeJS, Python web framework.",
        "Basics of JavaScript: Tags, Functions, Events.",
        "Hands-on session with HTML and JS.",
        "Introduction to JavaScript frameworks and libraries."
      ],
      "1:4":[
        "Role of Databases in web applications.",
        "Types of Databases and Database Connectivity.",
        "Create an e-commerce website like amazon.com.",
        "Presentation and discussion of the final projects."
      ],
      "2:0":[
        "Overview of UI/UX design and its importance.",
        "Introduction to Figma as a design tool.",
        "Exploring basic layout principles in Figma.",
        "Techniques for creating visually appealing designs."
      ],
      "2:1":[
        "Understanding the concept of design systems.",
        "Implementing design systems using Figma's features.",
        "Creating styles and utilizing Figma's Team Library for collaboration.",
        "Practical application of design systems in a team setting."
      ],
      "2:2":[
        "Working with components and understanding their role in design.",
        "Techniques for effective nesting and organizing elements.",
        "Exploring advanced techniques such as booleans and shapes.",
        "Practical exercises and application of advanced concepts."
      ],
      "2:3":[
        "Incorporating icons into designs and understanding their significance.",
        "Introduction to vector networks and how they enhance design.",
        "Exploring Figma plugins to streamline the design process.",
        "Hands-on practice with plugins for efficiency."
      ],
      "2:4":[
        "Overview of prototyping in Figma.",
        "Creating interactive prototypes for user testing.",
        "Integration of all learned concepts into a final project.",
        "Presentation and discussion of final projects."
      ],
      "3:0":[
        "Overview of Canva interface and tools",
        "Understanding the basic principles of poster design",
        "Choosing the right dimensions for your poster",
        "Exploring Canva templates and starting a new project",
        "Adding text and experimenting with fonts"
      ],
      "3:1":[
        "Uploading and inserting images into your poster:",
        "Exploring Canva Image Library",
        "Adjusting image size, position, and transparency:",
        "Adding icons and illustrations to enhance the visual appeal",
        "Tips for choosing high-quality and relevant images"
      ],
      "3:2":[
        "Understanding Color Theory",
        "Choosing a Color Palette",
        "Customizing Backgrounds",
        "Adding Gradients and Textures",
        "Ensuring Readability with Color Contrast"
      ],
      "3:3":[
        "Exploring Layout Options",
        "Creating Grids and Guides",
        "Layering and Grouping Elements",
        "Incorporating Shapes and Frames",
        "Applying Design Principles"
      ],
      "3:4":[
        "Reviewing and Refining",
        "Adding Final Touches",
        "Exporting and Tips"
      ],
      "4:0":[
        "Introduction to computer and programming languages",
        "Discussing Python's use in various fields",
        "Installation of Python.",
        "Introduction to algorithms and flowcharts.",
        "Writing and executing a basic programs."
      ],
      "4:1":[
        "Introduction to variables, values and Exploring fundamental data types.",
        "Understanding conditional statements",
        "Usage of Pass, Break and continue.",
        "Introduction to loops",
        "Writing loops and solving problems using iterative approaches."
      ],
      "4:2":[
        "Basics of functions, defining functions.",
        "Flow of function execution.",
        "Local and Global scope",
        "Function parameters and arguments.",
        "Recursions"
      ],
      "4:3":[
        "String – string slices",
        "String functions and its methods",
        "Illustrative programs using strings",
        "List methods and common operations.",
        "Illustrative programs using List"
      ],
      "4:4":[
        "Search – Linear and Binary",
        "Matrix operations in python",
        "Tower of Hanoi",
        "Collaborative mini project: students work in pairs/groups on a simple project",
        "Question and answer session."
      ],
      "5:0":[
        "Overview of Ethical Hacking and its importance.",
        "The role of ethical hackers in cybersecurity.",
        "Legal and ethical considerations in ethical hacking."
      ],
      "5:1":[
        "Basics of Networking and Protocols.",
        "Understanding IP addresses, subnets, and network devices.",
        "Introduction to Footprinting: Information gathering and reconnaissance."
      ],
      "5:2":[
        "Techniques for network scanning.",
        "Enumerating systems and services.",
        "Identifying vulnerabilities through scanning."
      ],
      "5:3":[
        "Gaining unauthorized access to systems.",
        "Exploiting vulnerabilities and weaknesses.5",
        "Techniques for privilege escalation."
      ],
      "5:4":[
        "Basics of web application security.",
        "Identifying and exploiting common web vulnerabilities.",
        "Final simulation: A hands-on ethical hacking scenario.",
        "Recap and discussion on ethical hacking best practices."
      ],
      "6:0":[
        "Overview of Game Engines, Engine Concepts, and Development Tools.",
        "Introduction to Unity and Unity Development Environment.",
        "IDE Basics, Unity Installation, and Exploring Unity IDE.",
        "Basic Unity Game Design: Unity Game Objects and Components of Game Objects."
      ],
      "6:1":[
        "C# Language Concepts for Unity Scripting.",
        "Creating Scripts and C# Coding Fundamentals.",
        "Game Loops and Functions.",
        "Simple Movement and Input: Implementing basic movement and input handling in Unity."
      ],
      "6:2":[
        "Physics Concepts: Rigidbody Components, Unity Colliders, Physics Materials.",
        "Scripting Collision Events.",
        "Game Design Strategies: Understanding Game Requirements and Game Mechanics."
      ],
      "6:3":[
        "Virtual Worlds: Moving Cameras, Setting Boundaries, Building a Tile World, Mini-Maps.",
        "Animation: Simple Unity Animation, Animator States, Scripting Animations, Animations, and Colliders."
      ],
      "6:4":[
        "User Interfaces: Unity Buttons, Other UI Controls, UI Design Concepts.",
        "Project Work: Continued development and refinement of the complete Game."
      ],

  });
  
  const x = ['Web Development', 'UI/UX', 'Poster Designing', 'Python Programming', 'Ethical Hacking', 'Game Development']

  const generateDates = (startWeek) => {
    const startDate = new Date("2024-04-15");
    startDate.setDate(startDate.getDate() + (startWeek - 1) * 7);

    const endDate = new Date(startDate);
    endDate.setDate(startDate.getDate() + 4);

    const dates = [];
    let currentDate = startDate;

    while (currentDate <= endDate) {
      dates.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return dates;
  };

  const handleWeekChange = (week) => {
    setSelectedWeek(week);
  };

  const handleViewDetails = (weekIndex) => {
    console.log(selectedWeek," ",weekIndex);
    const details = detailsByWeek[selectedWeek+":"+weekIndex];
    setPopupDetails(details);
  };

  const handleClosePopup = () => {
    setPopupDetails(null);
  };

  // const dates = generateDates(selectedWeek);
  const dates = [1,2,3,4,5]

  return (
    <div className="schedule-container" style={{ marginTop: '10vh', textAlign: 'center', padding:'2vh', background:'#fafafa', }}>
      <h2 style={{ fontSize: '3rem', background: 'linear-gradient(black, blue)', backgroundClip: 'text', WebkitTextFillColor: 'transparent', }}>Syllabus</h2>
      <div style={{ overflowX: 'auto' }}>
  <table style={{ width: "80%", margin: "0 auto", borderCollapse: "collapse", }}>
    <thead>
      <tr>
        {[1, 2, 3, 4, 5, 6].map((week) => (
          <th key={week} onClick={() => handleWeekChange(week)} style={{ padding: "10px", textAlign: "center", cursor: "pointer", backgroundColor: selectedWeek === week ? "#007BFF" : "whitesmoke", transition: "background-color 0.5s", minWidth: "100px" }}>
            {x[week - 1]} <br />(Week {week})
          </th>
        ))}
      </tr>
    </thead>
  </table>
</div>


      <table style={{ width: "80%", margin: "20px auto", borderCollapse: "collapse", }}>
        <thead>
          <tr>
            {/* <th style={{ border: "1px solid black", padding: "8px", backgroundColor: "#007BFF", color: "#fff" }}>Date</th> */}
            <th style={{ border: "1px solid black", padding: "8px", backgroundColor: "#007BFF", color: "#fff" }}>Day</th>
            <th style={{ border: "1px solid black", padding: "8px", backgroundColor: "#007BFF", color: "#fff" }}>Syllabus</th>
          </tr>
        </thead>
        <tbody>
          {dates.map((date, index) => (
            <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "white" : "whitesmoke" }}>
              <td style={{ border: "1px solid black", padding: "8px" }}><strong>Day {date}</strong></td>
              {/* <td style={{ border: "1px solid black", padding: "8px" }}>{["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday"][date.getDay()]}</td> */}
              <td style={{ border: "1px solid black", padding: "8px", textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <button onClick={() => handleViewDetails(index)} className="syllabus-link" style={{ display: "block", textAlign: "center", padding: "5px", textDecoration: "none", color: "#007BFF", cursor: "pointer", backgroundColor: "transparent", border: "none", transition: "background-color 0.3s", }}>View</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {popupDetails && <Popup details={popupDetails} onClose={handleClosePopup} />}
    </div>
  );
};

export default Schedule;